






















































































































import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import {
    getAlertColorByPriority,
    ID, isNullOrEmpty, matchedIndexIdInArray, OptionalCompany, parameterValueValidation, PRIVILEGE_KEYS, PRIVILEGE_TYPES, sortObjectByPropertyName,
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { CompanyDetail } from '../models/Companies';
import { CompaniesService } from '../api/CompaniesService';



@Component({
    components: {
        Loading,
        Combobox,
        Button,
        SectionTitle,
        MultipleSelect,
        DeleteConfirmation,
        Input
    }
})
export default class ConfigureGuardianModule extends Mixins(
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
) {
    @Prop({default: null}) companyData: CompanyDetail;
    @Prop({default: false}) visible: boolean;
    @Prop({default: false}) hasActiveService: boolean;
    @Prop({default: -1}) companyId: number;
    modalTitle: string = 'Configuración de El Guardián';
    activeColor: string = 'primary';
    inactiveColor: string = getAlertColorByPriority();
    activeGuardianText: string = 'Activar';
    deactivateGuardianText: string = 'Desactivar';
    pendingRequest: boolean = false;
    deactivateIcon: string = 'mdi-close-circle';
    activateIcon: string = 'mdi-checkbox-marked-circle';
    summaryDeactivate: string[] = [];
    username: string = '';
    userpassword: string = '';
    settingsPanel: null | number = 0;
    deactivatingService: boolean = false;

    get canSaveGuardianConfig(){
        return !isNullOrEmpty(this.username) && !isNullOrEmpty(this.userpassword);
    }

    @Watch('companyData', { immediate: true, deep: true })
    onCompanyDataChange(value: CompanyDetail) {
        // this.hasActiveGuardian = value.guardian.is_active
        this.updateUsername(value.guardian.username);
        this.updateUserpassword(value.guardian.password);
    }

    updateUsername(value){
        this.username = value;
    }

    updateUserpassword(value){
        this.userpassword = value;
    }

    pendingService(value){
        this.pendingRequest = value;
    }

    //delete modal
    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    get getColorDeactivateBtn(){
        return !this.hasActiveService ? this.activeColor : this.inactiveColor;
    }

    get getBtnLabel(){
        return this.hasActiveService ? this.deactivateGuardianText : this.activeGuardianText
    }

    get companyHasActiveService(){
        return this.hasActiveService
    }

    buttonActivateOrUpdate(){
        if(!this.hasActiveService){
            this.activateService();
            return;
        }
        this.updateServiceCredentials();
    }



    updateServiceCredentials(){
        //WS Patch Credenciales
        this.pendingService(true);
        CompaniesService.patchGuardianService(
            this.companyId,
            this.username,
            this.userpassword
        ).then((res) => {
            this.handleSuccessAction(res);
            this.setGuardianCredentials(res.guardian);
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudo actualizar la configuracion del sistema')
        }).finally(() => {
            this.pendingService(false);
        })
    }

    activateService(){
        //WS - Activar Servicio
        this.pendingService(true);
        CompaniesService.activateGuardianService(
            this.companyId,
            this.username,
            this.userpassword
        ).then((res) => {
            this.handleSuccessAction(res);
            this.setGuardianCredentials(res.guardian);
            this.setHasActiveService(res.guardian);
            this.closeModal();
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudo activar el Sistema')
        }).finally(() => {
            this.pendingService(false);
        })
    }

    deactivateService(){
        //WS Desactivar servicio
        this.deactivatingService = true;
        CompaniesService.deactivateGuardian(
            this.companyId
        ).then((res) => {
            let newCredentials = res.guardian;
            this.handleSuccessAction(res);
            this.setHasActiveService(newCredentials);
            this.setGuardianCredentials(newCredentials);
            this.closeModal();
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudo desactivar el sistema El Guardian')
        }).finally(() => {
            this.deactivatingService = false;
        })
    }

    

    clickDeactivateButton(){
        //Click en boton activar/desactivar
        this.deactivateAlert();
    }


    @Emit()
    setHasActiveService(value: CompanyDetail['guardian']) {}

    @Emit()
    setGuardianCredentials(value: CompanyDetail["guardian"]) {
        this.updateUsername(value.username);
        this.updateUserpassword(value.password);
        return value;
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }


    deactivateAlert() {
        let companyName = this.companyData.name;
        this.deleteModalTitle = 'Desactivar Sistema "El Guardián"';
        this.deleteBody =
            `¿Realmente desea Desactivar el Sistema "El Guardián" para <b>${companyName}</b>?`;
            this.summaryDeactivate = [
                `Esta empresa dejará de recibir información de "El Guardián".</br>`,
                `Ya no se actualizará el Reporte de "El Guardián" para esta empresa.</br>`,
            ]
        this.confirmationDelete = true;
    }
  

    deactivateAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.deactivateService();
        } else {
            this.confirmationDelete = false;
        }
    }


    

    @Emit()
    closeModal() {}

    mounted() {
        this.$nextTick(() => {
            this.updateUsername(this.companyData.guardian.username);
            this.updateUserpassword(this.companyData.guardian.password);
        });
    }

    
}
